import { Link } from "react-router-dom";
import { topRatedMovies } from "@/mocks/movies";

export default function MovieRanking() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门排行榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            口碑最好的高分电影推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {topRatedMovies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer group"
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                <span
                  className={`text-lg font-heading font-bold ${
                    index < 3 ? "text-accent-500" : "text-foreground-400"
                  }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>

              <div className="w-12 h-16 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`${movie.title} - 555电影网`}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  {movie.year} · {movie.director}
                </p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1">
                <span className="text-sm font-bold text-accent-500 whitespace-nowrap">
                  {movie.rating}
                </span>
                <span className="text-xs text-foreground-400">分</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部排行
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}